import styled from 'styled-components';
import { SIZE, LAYERS } from '../../common/sizes';
import { DEFAULT_FONT_FAMILY, BUTTON_ACTION_HEIGHT } from 'common/constants';
import { Label } from 'common/baseComponents';

export const InputFieldMainContainer = styled.div`
    display: flex;
    flex:1;
    justify-content: flex-start;
`;

export const LabelContainer = styled.div`
    display: flex;
    color: #111;
    aling-items: center;
    margin: 0 ${SIZE.ONE}px;
    ${Label} {
        color: inherit;
        font-size: 14px;
        align-items: center;
    }
`;

export const Input = styled.input`
    border: none;
    width: ${SIZE.FIVE}px;
    height: ${SIZE.THREE}px;
    flex-grow: 0;
    aling-items: center;
    justify-content: center;
    font-family: Rubik;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #272727;
    &hover{
        border: none;
    }
    outline: none !important;
    

    
`
export const InputAll = styled.input`
    border: none;
    width: ${SIZE.FIVE}px;
    height: ${SIZE.THREE}px;
    flex-grow: 0;
    aling-items: center;
    justify-content: center;
    font-family: Rubik;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #272727;
    &hover{
        border: none;
    }
`
export const PhoneInputBox = styled.div`
    width: ${SIZE.FIVE}px;
    height: ${SIZE.THREE}px;
    flex-grow: 0;
    aling-items: center;
    justify-content: center;
    margin: 0 0 0 0;
    padding: ${SIZE.ONE}px;
    border-radius: 5px;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px rgba(130, 130, 130, 0.5);
    background-color: #ffffff;

`

export const Hyphen = styled.div`
    width: 5px;
    height: 19px;
    flex-grow: 0;
    margin: ${SIZE.TWO}px ${SIZE.ONE}px;
    font-family: Rubik;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #272727;
`